import React, { useEffect, useRef } from "react";
import Icon from "../icon/Icon";
import { Pagination, PaginationLink, PaginationItem,Card } from "reactstrap";
import { Block } from "../block/Block";

const PaginationComponent = ({ itemPerPage, totalItems, paginate, currentPage }) => {
  const pageNumbers = [];

  const myRef = useRef(0)
    useEffect(() => {
        var mainid = document.getElementById(currentPage)
        if (currentPage !== 1) {
            mainid.scrollIntoView()
        }
    }, [currentPage])

  for (let i = 1; i <= Math.ceil(totalItems / itemPerPage); i++) {
    pageNumbers.push(i);
  }
  
  const nextPage = () => {
      paginate(currentPage + 1);
  };

  const prevPage = () => {
    paginate(currentPage - 1);
  };

    return (
        <Block >
            <Pagination aria-label="Page navigation example" >
                <PaginationItem disabled={currentPage - 1 === 0 ? true : false}>
                    <PaginationLink
                        className="page-link-prev"
                        onClick={(ev) => {
                            ev.preventDefault();
                            prevPage();
                        }}
                        href="#prev"
                    >
                        <Icon name="chevrons-left" />
                        <span>Prev</span>
                    </PaginationLink>
                </PaginationItem>

                <div style={{ overflowY: 'scroll' }}>
                    <Card className="card-bordered card-stretch">
                        <Pagination aria-label="Page navigation example" >
                            {pageNumbers.map((item) => {
                                return (
                                    <PaginationItem ref={myRef} className={currentPage === item ? "active" : ""} key={item} id={item}>
                                        <PaginationLink
                                            tag="a"
                                            href="#pageitem"
                                            onClick={(ev) => {
                                                ev.preventDefault();
                                                paginate(item);
                                            }}
                                        >
                                            {item}
                                        </PaginationLink>

                                    </PaginationItem>
                                );
                            })}

                            
                        </Pagination>

                    </Card>
                </div>

                <PaginationItem disabled={pageNumbers[pageNumbers.length - 1] === currentPage}>
                    <PaginationLink
                        className="page-link-next"
                        onClick={(ev) => {
                            ev.preventDefault();
                            nextPage();
                        }}
                        href="#next"
                    >
                        <span>Next</span>
                        <Icon name="chevrons-right" />
                    </PaginationLink>
                </PaginationItem>
            </Pagination>
            
        </Block>
  );
};
export default PaginationComponent;
